"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SkeletonLoader", {
  enumerable: true,
  get: function () {
    return _SkeletonLoader.default;
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _Loader.default;
  }
});
var _Loader = _interopRequireDefault(require("./Loader.js"));
var _SkeletonLoader = _interopRequireDefault(require("./SkeletonLoader.js"));